<template>
  <group-list :data='data'/>
</template>
<!--<template>-->
<!--  <page :total="10" :size="4"/>-->
<!--</template>-->

<script>
  import groupList from './groupList';
  import page from '@/components/page';

  export default {
    components: {
      groupList,
      page
    },
    props: {
      data: Array,
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/elite/lawer.vue